import {
    IconCancelRegular,
    IconDeviceSignalRegular,
    IconRouterRegular,
    Row,
    RowList,
    Text1,
    Text6,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ModalTestInformation: React.FC<{
    preventLink?: boolean;
    onSelect?: (stepper: 'main' | 'interpretation' | 'connection' | 'advices') => void;
}> = ({ preventLink = false, onSelect }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const storage = localStorage.getItem('storage');
    const { trackingScreenView } = new TrackingEvents();
    let fiber: any;
    if (storage) {
        const storageJson = JSON.parse(storage);
        fiber = storageJson;
    }

    const sendToNative = (url: string, title: any) => {
        const type = 'modeFlow-backgroundWhite';
        const queryParams = {};
        if (navigateParams(type, url, queryParams, fiber, title)) {
            navigate(url);
        }
    };
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='modalTestInformation-page'>
            <div className='modalTestInformation-page__title'>
                <Text6>{t('informationAboutTest')}</Text6>
            </div>
            <Row
                asset={<IconDeviceSignalRegular />}
                title={t('mobileDataConnectionTitle')}
                description={t('mobileDataConnectionDescription')}
            ></Row>
            <Row
                asset={<IconRouterRegular />}
                title={t('wifiNetworkConnectionTitle')}
                description={t('wifiNetworkConnectionDescription')}
            ></Row>
            <Row
                asset={<IconCancelRegular />}
                title={t('closeOtherAppsTitle')}
                description={t('closeOtherAppsDescription')}
            ></Row>
            <div className='modalTestInformation-page__subtitle'>
                <Text1 medium color={skinVars.colors.textSecondary}>
                    {t('mayInterestYou')}
                </Text1>
            </div>
            <div className='modalTestInformation-page__rowClick'>
                <RowList>
                    <Row
                        title={t('interpretTest')}
                        onPress={() => {
                            if (!preventLink) {
                                sendToNative('/fiber/fiber-modal-test-interpretation', t('interpretTest'));
                            } else {
                                if (onSelect) onSelect('interpretation');
                            }
                        }}
                    ></Row>

                    <Row
                        title={t('yourConnectionIsSlow')}
                        onPress={() => {
                            if (!preventLink) {
                                sendToNative('/fiber/fiber-modal-slow-connection', t('yourConnectionIsSlow'));
                            } else {
                                if (onSelect) onSelect('connection');
                            }
                        }}
                    ></Row>

                    <Row
                        title={t('tipsToImproveConnection')}
                        onPress={() => {
                            if (!preventLink) {
                                sendToNative(
                                    '/fiber/fiber-modal-tips-to-improve-connection',
                                    t('tipsToImproveConnection'),
                                );
                            } else {
                                if (onSelect) onSelect('advices');
                            }
                        }}
                    ></Row>
                </RowList>
            </div>
        </div>
    );
};

export default ModalTestInformation;
